import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Intro = ({ onComplete }) => {
    const [loadingText, setLoadingText] = useState('INITIALIZING SYSTEM...');

    useEffect(() => {
        const textSequence = [
            { text: 'LOADING PROJECTS...', delay: 1400 },
            { text: 'OPTIMIZING ASSETS...', delay: 2300 },
            { text: 'READY', delay: 3050 }
        ];

        const timeouts = textSequence.map(item =>
            setTimeout(() => setLoadingText(item.text), item.delay)
        );

        // Signal completion
        const completeTimeout = setTimeout(() => {
            onComplete();
        }, 3400);

        return () => {
            timeouts.forEach(clearTimeout);
            clearTimeout(completeTimeout);
        };
    }, [onComplete]);

    return (
        <motion.div
            className="intro-content"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.6 }}
        >
            <h1 className="name-title">JOSHUA Z</h1>
            <div className="separator-line"></div>
            <p className="role-subtitle">FULL STACK DEVELOPER</p>

            <div className="loading-container">
                <div className="loading-bar-bg">
                    <div className="loading-bar-progress"></div>
                </div>
                <p className="loading-text">{loadingText}</p>
            </div>
        </motion.div>
    );
};

export default Intro;
